

























































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { User } from '@/data/models/user.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { download } from '@/data/utils/helper';
import { UserService } from '@/data/services/user.service';

@Component
export default class OperatoreList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: () => [] }) selected!: User[];
	
	@Inject('CrudService') crudService!: CrudService<User>;
	@Inject('UserService') userService!: UserService;

	rows: User[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('user');
	checkedRows: User[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadOperatori() {

		const datareq = this.crudService.searchEntities(
			User,
			'user',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			User,
			'user',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	print(row: User) {
		const loading = this.$buefy.loading.open({});
		this.userService.printCompensi(row.id).then((response) => {
			download(response, 'stampa-compensi.pdf');
		}).catch(({ data }) => {
			if (data) {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			}
		}).finally(() => loading.close());
	}

	openOperatore(item: User) {
		this.$emit('open', item);
	}

	statsOperatore(item: User) {
		this.$emit('stats', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadOperatori();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadOperatori();
	}

	onCheck(checked: User[]) {
		this.$emit('update:selected', checked);
	}

	deleteOperatore(item: User) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-operatore-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(User, 'user', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.loadOperatori();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			}
		});
	}

}
